"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var categories_1 = require("@common/services/categories");
var SelectTree_1 = __importDefault(require("@features/ItemCommon/components/common/SelectTree"));
function ItemCategoryEditable(_a) {
    var isNotEditable = _a.isNotEditable, value = _a.value, setValue = _a.setValue, domain = _a.domain, automationListsPermission = _a.automationListsPermission;
    var t = (0, react_i18next_1.useTranslation)().t;
    var categories = (0, categories_1.useGetCategoriesQuery)(domain).data;
    return (react_1.default.createElement(react_1.default.Fragment, null, categories && (react_1.default.createElement(SelectTree_1.default, { cyName: "job-category", label: t('ITEM.CATEGORY'), data: categories, value: value, setValue: setValue, isNotEditable: isNotEditable, domain: domain, automationListsPermission: automationListsPermission }))));
}
exports.default = ItemCategoryEditable;
